var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#CC191E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1621 6.69762C12.516 6.69961 13.4016 6.70822 14.3428 6.746L14.6769 6.76059C15.6241 6.805 16.5706 6.88189 17.0406 7.01247C17.667 7.18878 18.1588 7.70182 18.3252 8.35273C18.5903 9.38676 18.6234 11.4031 18.6274 11.8916L18.6281 11.9924V12.1077C18.6234 12.5962 18.5903 14.6132 18.3252 15.6466C18.1568 16.2995 17.6643 16.8132 17.0406 16.9869C16.5706 17.1175 15.6241 17.1943 14.6769 17.2388L14.3428 17.254C13.4016 17.2911 12.516 17.3004 12.1621 17.3017L12.0063 17.3024H11.8373C11.0883 17.2977 7.9557 17.2639 6.95879 16.9869C6.33307 16.8106 5.84058 16.2975 5.6742 15.6466C5.40907 14.6126 5.37593 12.5962 5.37195 12.1077V11.8916C5.37593 11.4031 5.40907 9.38609 5.6742 8.35273C5.84256 7.69983 6.33505 7.18613 6.95945 7.01313C7.9557 6.7354 11.0889 6.70159 11.8379 6.69762H12.1621ZM10.674 9.68039V14.3203L14.651 12.0003L10.674 9.68039Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.6ae22f4ed4e4e545a5b2497cbf5ec18a.svg";
export { ForwardRef as ReactComponent };